import { updateCompany } from "../components/axios/Companies";
import { updateEmployee } from "../components/axios/Employees";
import { updateTraining } from "../components/axios/Trainings";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import timezone from "dayjs/plugin/timezone";
import advancedFormat from "dayjs/plugin/advancedFormat";
import axios from "axios";
import { baseUrl } from "../components/axios/BaseUrl";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);
// Close tooltip if cancel is clicked
// Close tooltip and make the correct axios request if save is clicked
export const handleCancelOrSave = (e, props) => {
  let { isDetailsOpen, detailsOpen, values, actionCategory } = props;
  if (e.target.name === "cancel") {
    isDetailsOpen(false);
  } else if (detailsOpen && actionCategory === "Company") {
    updateCompany({ company: { ...values.current, isDetailsOpen } });
    isDetailsOpen(false);
  } else if (detailsOpen && actionCategory === "Employee") {
    updateEmployee({ employee: { ...values.current, isDetailsOpen } });
    isDetailsOpen(false);
  } else if (detailsOpen && actionCategory === "Training") {
    updateTraining({ training: { ...values.current, isDetailsOpen } });
    isDetailsOpen(false);
  }
};

export const safeDayjsFormat = (
  date,
  fmt = "MM/DD/YYYY",
  tz = "US/Central"
) => {
  if (!date) return ""; // null, undefined, empty
  const d = dayjs.tz(date, tz);
  if (!d.isValid()) return ""; // invalid string or timestamp
  return d.format(fmt);
};

// open details tooltip
// and propagate tooltip based on what category is currently selected
export const handleDetailsClick = (props) => {
  return () => {
    props.isDetailsOpen(true);
    if (props.actionCategory === "Company") {
      let {
        id,
        dotNumber,
        companyName,
        address,
        city,
        state,
        zip,
        phone,
        fax,
        email,
        contact,
        alcoholAndDrug,
        training,
        reminders,
        clearinghouse,
        companyNotes,
        uCR,
        rIN,
        usDotHazmatRegistration,
        cabCard,
        twentyTwoNinety,
      } = props.rowClicked;
      props.values.current = Object.assign(
        {
          id,
          dotNumber,
          companyName,
          address,
          city,
          state,
          zip,
          phone,
          fax,
          email,
          contact,
          alcoholAndDrug,
          training,
          reminders,
          clearinghouse,
          companyNotes,
          uCR,
          rIN,
          usDotHazmatRegistration,
          cabCard,
          twentyTwoNinety,
        },
        props.rowClicked
      );
      props.setChecked({
        alcoholAndDrug: props.values.current.alcoholAndDrug,
        training: props.values.current.training,
        reminders: props.values.current.reminders,
        clearinghouse: props.values.current.clearinghouse,
      });
    } else if (props.actionCategory === "Employee") {
      let {
        id,
        lastName,
        firstName,
        state,
        consortium,
        isDriver,
        cdl,
        employeeNotes,
      } = props.rowClicked;
      props.values.current = Object.assign(
        {
          id,
          lastName,
          firstName,
          state,
          consortium,
          isDriver,
          cdl,
          employeeNotes,
        },
        props.rowClicked
      );
      props.setChecked({
        isDriver: props.values.current.isDriver,
      });
    } else if (props.actionCategory === "Training") {
      let { date, instructor, title, attendees, courses } = props.rowClicked;
      props.values.current = Object.assign(
        {
          date,
          instructor,
          title,
          attendees,
          courses,
        },
        props.rowClicked
      );
    }
  };
};

// Gets the info from a row that is clicked for propagating the tooltip
export const handleChange = (e, props, s) => {
  // check if this is change has to do with a date
  if (e.$d !== undefined && e.$d !== null) {
    // Create timezone-aware date like in AddEmployeeModal
    const selectedDate = dayjs(e.$d);
    const date = dayjs.tz(
      `${selectedDate.year()}-${
        selectedDate.month() + 1
      }-${selectedDate.date()} 12:00:00`,
      "YYYY-M-D HH:mm:ss",
      "US/Central"
    );

    if (s === "hireDate") {
      props.values.current.hireDate = date;
    } else if (s === "terminationDate") {
      props.values.current.terminationDate = date;
    } else if (s === "birthday") {
      props.values.current.birthday = date;
    } else {
      props.values.current.date = date;
    }
  } else if (
    // check if this change has to do with a checkbox category
    e.target.name === "alcoholAndDrug" ||
    e.target.name === "reminders" ||
    e.target.name === "training" ||
    e.target.name === "isDriver" ||
    e.target.name === "clearinghouse" ||
    e.target.name === "DMV" ||
    e.target.name === "CDL" ||
    e.target.name === "HAZMAT" ||
    e.target.name === "PHYS" ||
    e.target.name === "HME"
  ) {
    if (props.values.current[e.target.name]) {
      props.values.current[e.target.name] = false;
      props.setChecked({ ...props.checked, [e.target.name]: false });
    } else {
      props.values.current[e.target.name] = true;
      props.setChecked({ ...props.checked, [e.target.name]: true });
    }
  } else {
    // update the new key value pair
    props.values.current[e.target.name] = e.target.value;
  }
};

// Getting the total number of drivers
export const countDrivers = (data) => {
  return data.reduce((total, item) => {
    if (item.isDriver === true && item.isHidden === false) {
      total++;
    }
    return total;
  }, 0);
};

// Maps the datagrid (table) with  companies
export const mapCompanies = (data, callback) => {
  let companyRows = [];
  if (data && data.length >= 1) {
    for (let i = 0; i < data.length; i++) {
      let currentCompany = data[i];
      if (
        currentCompany.isHidden !== true &&
        currentCompany.isHidden !== "true"
      ) {
        companyRows.push({
          id: currentCompany._id || "",
          companyId: currentCompany._id || "",
          dotNumber: currentCompany?.companyDetails?.usDotNumber || "",
          companyName: currentCompany?.companyName || "",
          address: currentCompany?.companyDetails?.address?.street || "",
          city: currentCompany?.companyDetails?.address?.city || "",
          state: currentCompany?.companyDetails?.address?.state || "",
          zip: currentCompany?.companyDetails?.address?.zip || "",
          phone: currentCompany?.companyDetails?.phone || "",
          fax: currentCompany?.companyDetails?.fax || "",
          email: currentCompany?.companyDetails?.email || "",
          contact: currentCompany?.companyDetails?.contact || "",
          alcoholAndDrug:
            currentCompany?.companyDetails?.programs?.alcoholAndDrug || false,
          training: currentCompany?.companyDetails?.programs?.training || false,
          reminders:
            currentCompany?.companyDetails?.programs?.reminders || false,
          clearinghouse:
            currentCompany?.companyDetails?.programs?.clearinghouse || false,
          companyNotes: currentCompany?.companyDetails?.companyNotes || "",
          isHidden: currentCompany?.isHidden || false,
          updatedAt: safeDayjsFormat(
            currentCompany?.updatedAt,
            "MM/DD/YYYY h:mma"
          ),
          updatedBy: currentCompany?.updatedBy || "",
          uCR: currentCompany?.companyDetails?.uCR || "",
          rIN: currentCompany?.companyDetails?.rIN || "",
          usDotHazmatRegistration:
            currentCompany?.companyDetails?.usDotHazmatRegistration || "",
          cabCard: currentCompany?.companyDetails?.cabCard || "",
          twentyTwoNinety:
            currentCompany?.companyDetails?.twentyTwoNinety || "",
        });
      }
    }
  }
  callback(companyRows);
};

// Maps the datagrid (table) with employees
export const mapEmployees = (employees, callback) => {
  let employeeRows = [];
  if (employees && employees.length >= 1) {
    for (let i = 0; i < employees.length; i++) {
      let currentEmployee = employees[i];
      if (currentEmployee.isHidden === false) {
        const hireDate = currentEmployee.hireDate
          ? safeDayjsFormat(currentEmployee.hireDate, "MM/DD/YYYY")
          : null;
        const birthday = currentEmployee.birthday
          ? safeDayjsFormat(currentEmployee.birthday, "MM/DD/YYYY")
          : null;
        const terminationDate = currentEmployee.terminationDate
          ? safeDayjsFormat(currentEmployee.terminationDate, "MM/DD/YYYY")
          : null;
        employeeRows.push({
          id: currentEmployee._id,
          cdl: currentEmployee.cdl,
          employeeId: currentEmployee._id,
          lastName: currentEmployee.lastName,
          firstName: currentEmployee.firstName,
          state: currentEmployee.state,
          consortium: currentEmployee.consortium,
          isDriver: currentEmployee.isDriver,
          isHidden: currentEmployee.isHidden,
          employeeNotes: currentEmployee.employeeNotes,
          updatedAt: safeDayjsFormat(
            currentEmployee.updatedAt,
            "MM/DD/YYYY h:mma"
          ),
          updatedBy: currentEmployee.updatedBy,
          hireDate,
          birthday,
          terminationDate,
        });
      }
    }
  }
  callback(employeeRows);
};

// Maps the datagrid (table) with trainings
export const mapTrainings = (trainings, callback) => {
  let trainingRows = [];
  if (trainings && trainings.length >= 1) {
    for (let i = 0; i < trainings.length; i++) {
      let currentTraining = trainings[i];
      trainingRows.push({
        title: currentTraining.courseTitle,
        attendees: currentTraining.attendees,
        date: safeDayjsFormat(currentTraining.trainingDate, "MM/DD/YYYY"),
        instructor: currentTraining.instructor,
        isHidden: currentTraining.isHidden,
        nextDate: `${dayjs
          .tz(currentTraining.trainingDate, "US/Central")
          .add(1, "year")
          .diff(dayjs(), "day")} Days`,
        id: currentTraining._id,
        trainingId: currentTraining._id,
        courses: currentTraining.courses,
        updatedAt: safeDayjsFormat(
          currentTraining.updatedAt,
          "MM/DD/YYYY h:mma"
        ),
        updatedBy: currentTraining.updatedBy,
      });
    }
  }
  callback(trainingRows);
};

export const mapTrainingsByAttendee = (
  trainingSessions,
  companyName,
  attendeeName
) => {
  // Filter training sessions by companyName
  const filteredSessions = trainingSessions.filter(
    (session) => session.companyName === companyName
  );

  // Map through the filtered sessions and filter attendees by firstName and lastName
  const mappedSessions = filteredSessions
    .map((session) => ({
      ...session,
      attendees: session.attendees.filter((attendee) =>
        `${attendee.firstName} ${attendee.lastName}`
          .toLowerCase()
          .includes(attendeeName.toLowerCase())
      ),
    }))
    .filter((session) => session.attendees.length > 0); // Filter out sessions with no matching attendees

  return mappedSessions;
};

export const mapAllEmployees = (employees) => {
  let employeeRows = [];
  if (employees && employees.length >= 1) {
    for (let i = 0; i < employees.length; i++) {
      let currentEmployee = employees[i];
      const hireDate = currentEmployee.hireDate
        ? safeDayjsFormat(currentEmployee.hireDate, "MM/DD/YYYY")
        : null;
      const birthday = currentEmployee.birthday
        ? safeDayjsFormat(currentEmployee.birthday, "MM/DD/YYYY")
        : null;
      const terminationDate = currentEmployee.terminationDate
        ? safeDayjsFormat(currentEmployee.terminationDate, "MM/DD/YYYY")
        : null;
      employeeRows.push({
        id: currentEmployee._id,
        cdl: currentEmployee.cdl,
        employeeId: currentEmployee._id,
        lastName: currentEmployee.lastName,
        firstName: currentEmployee.firstName,
        state: currentEmployee.state,
        consortium: currentEmployee.consortium,
        isDriver: currentEmployee.isDriver,
        isHidden: currentEmployee.isHidden,
        companyName: currentEmployee.companyName,
        companyId: currentEmployee.companyId,
        employeeNotes: currentEmployee.employeeNotes,
        hireDate,
        birthday,
        terminationDate,
      });
    }
  }
  return employeeRows;
};

export const mapAllUsers = (users) => {
  let userRows = [];
  if (users && users.length >= 1) {
    for (let i = 0; i < users.length; i++) {
      let currentUser = users[i];
      userRows.push({
        id: currentUser._id,
        name: `${currentUser.firstName} ${currentUser.lastName}`,
        password: currentUser.password,
        isAdmin: currentUser.isAdmin,
        company: currentUser.companyName,
        email: currentUser.email,
        firstName: currentUser.firstName,
        lastName: currentUser.lastName,
        __v: 0,
      });
    }
  }
  return userRows;
};

export const mapPercentage = (percentage) => {
  let percentageRow = [];
  if (percentage && percentage.length >= 1) {
    for (let i = 0; i < percentage.length; i++) {
      let currentPercentage = percentage[i];
      percentageRow.push({
        id: currentPercentage._id,
        alcoholPercentage: currentPercentage.alcoholPercentage,
        drugPercentage: currentPercentage.drugPercentage,
        updatedBy: currentPercentage.updatedBy,
        updatedAt: safeDayjsFormat(
          currentPercentage.updatedAt,
          "MM/DD/YYYY h:mma"
        ),
        __v: 0,
      });
    }
  }
  return percentageRow;
};

export const mapEmployeeScreenings = (screenings) => {
  let screeningRows = [];
  if (screenings && screenings.length >= 1) {
    for (let i = 0; i < screenings.length; i++) {
      let currentScreening = screenings[i];
      if (
        currentScreening?.selectedEmployees &&
        currentScreening?.selectedEmployees.length >= 1
      ) {
        for (let x = 0; x < currentScreening?.selectedEmployees.length; x++) {
          let currentEmployee = currentScreening?.selectedEmployees[x];
          screeningRows.push({
            id: currentEmployee._id + currentScreening._id,
            companyName: currentEmployee.companyName,
            companyId: currentEmployee.companyId,
            firstName: currentEmployee.firstName,
            lastName: currentEmployee.lastName,
            result: currentEmployee.status,
            screen: currentScreening.screeningType,
            quarterSelected: currentScreening.screeningQuarter,
            year: currentScreening.screeningYear,
            consortium: currentScreening.consortium,
          });
        }
      }
    }
  }
  return screeningRows;
};

export const mapSingleEmployeeScreenings = (screenings) => {
  let screeningRows = screenings.map((screening) => {
    const employeeStatus =
      screening.employeeStatus || screening.selectedEmployee;
    const baseScreening = {
      id: screening._id,
      screeningId: screening._id,
      employeeId: employeeStatus._id || employeeStatus.employeeId,
      companyName: employeeStatus.companyName,
      companyId: employeeStatus.companyId,
      firstName: employeeStatus.firstName,
      lastName: employeeStatus.lastName,
      result: employeeStatus.status,
      screen: screening.screeningType,
      date: safeDayjsFormat(screening.screeningDate, "MM/DD/YYYY"),
      year: screening.screeningYear,
      consortium: screening.consortium,
      failureReason: employeeStatus.failureReason || "",
      screeningReason: screening.screeningReason || "",
    };

    // Add quarter for drug and alcohol screenings
    if (
      screening.screeningType === "Drug" ||
      screening.screeningType === "Alcohol"
    ) {
      baseScreening.quarterSelected = screening.screeningQuarter;
    }

    return baseScreening;
  });

  return screeningRows;
};

export const mapScreenings = (screenings) => {
  let screeningRows = [];
  if (screenings && screenings.length >= 1) {
    for (let i = 0; i < screenings.length; i++) {
      let currentScreenings = screenings[i];
      screeningRows.push({
        id: currentScreenings._id,
        isCommitted: currentScreenings.isCommitted,
        screeningDate: safeDayjsFormat(
          currentScreenings.screeningDate,
          "MM/DD/YYYY"
        ),
        consortium: currentScreenings.consortium,
        screeningType: currentScreenings.screeningType,
        screeningYear: currentScreenings.screeningYear,
        screeningQuarter: currentScreenings.screeningQuarter,
        totalMembers: currentScreenings.totalMembers,
        requiredMembers: currentScreenings.requiredMembers,
        selectedMembers: currentScreenings.selectedMembers,
      });
    }
  }
  return screeningRows;
};

export const mapCompanyScreenings = ({ employees, companies, screenings }) => {
  // Create Set of active company IDs for faster lookup
  const activeCompanyIds = new Set(
    companies.map((company) => company._id.toString())
  );

  // Initialize mappings
  const companyMapping = {};
  const selectedEmployeesMapping = {};
  let allDrivers = 0;
  let totalSelected = 0; // New counter for total selected employees

  // Step 1: Iterate through the employees array to count employees and drivers
  employees.forEach((employee) => {
    const { companyId, isDriver } = employee;

    // Only process employees from active companies
    if (activeCompanyIds.has(companyId)) {
      if (!companyMapping[companyId]) {
        companyMapping[companyId] = {
          totalEmployees: 0,
          totalDrivers: 0,
          totalSelected: 0,
          screeningYear: null,
          screeningQuarter: null,
          screeningType: "",
        };
        selectedEmployeesMapping[companyId] = [];
      }

      // Count all active employees
      companyMapping[companyId].totalEmployees += 1;

      // Count drivers (these are the ones eligible for screening)
      if (isDriver === true || isDriver === "true") {
        companyMapping[companyId].totalDrivers += 1;
        allDrivers += 1;
      }
    }
  });

  // Step 2: Iterate through the screenings array to count selected and record year and quarter
  screenings.forEach((screening) => {
    totalSelected += screening.selectedEmployees.length; // Add to total selected count

    screening.selectedEmployees.forEach((employee) => {
      const { companyId } = employee;

      if (companyMapping[companyId]) {
        companyMapping[companyId].totalSelected += 1;
        companyMapping[companyId].screeningYear = screening.screeningYear;
        companyMapping[companyId].screeningQuarter = screening.screeningQuarter;
        companyMapping[companyId].screeningType = screening.screeningType;
        // Collect selected employees
        employee.screeningType = screening.screeningType;
        selectedEmployeesMapping[companyId].push(employee);
      }
    });
  });

  // Step 3: Generate the final array with company details and selected employees
  const finalArray = companies.map((company) => {
    const companyId = company._id;
    const mapping = companyMapping[companyId] || {
      totalEmployees: 0,
      totalDrivers: 0,
      totalSelected: 0,
      screeningYear: null,
      screeningQuarter: null,
    };

    return {
      id: companyId,
      address: company.companyDetails.address,
      companyName: company.companyName,
      email: company.companyDetails.email,
      contact: company.companyDetails.contact,
      totalEmployees: mapping.totalEmployees,
      totalDrivers: mapping.totalDrivers,
      totalSelected: mapping.totalSelected,
      screeningYear: mapping.screeningYear,
      screeningQuarter: mapping.screeningQuarter,
      employees: selectedEmployeesMapping[companyId] || [],
    };
  });

  return {
    finalArray,
    allEmployees: totalSelected, // Changed to return total selected instead
    allDrivers, // Still only includes drivers from active companies
  };
};

export function groupEmployeesByCompany(reminders, companies) {
  const groupedData = {};
  const companyMap = {};

  // First, map companies by their ID for quick access
  companies.forEach((company) => {
    companyMap[company._id] = {
      address: company.companyDetails.address,
    };
  });

  reminders.forEach((entry) => {
    const companyKey = entry.companyId;

    // Initialize the company in the grouped data if not already present
    if (!groupedData[companyKey]) {
      groupedData[companyKey] = {
        companyName: entry.companyName,
        companyId: entry.companyId,
        address: companyMap[companyKey]
          ? companyMap[companyKey].address
          : "No address found",
        employees: [], // Directly store employees here
        reminderType: entry.reminderType, // Set the reminderType to the string from the entry
      };
    }

    // Add the employee along with their reminder details directly to the company's employee list
    groupedData[companyKey].employees.push({
      firstName: entry.firstName,
      lastName: entry.lastName,
      employeeId: entry.employeeId,
      reminderType: entry.reminderType, // Reminder type for the employee (same as company reminderType)
      dueDate: entry.dueDate,
      message: entry.message,
    });
  });

  // Convert the map object into an array of companies and sort alphabetically by companyName
  return Object.values(groupedData).sort((a, b) =>
    a.companyName.localeCompare(b.companyName)
  );
}

export function aggregateScreeningsSummaryReportData(screenings) {
  // Reduce the array to a single object
  return screenings.reduce((acc, item) => {
    // Set common properties if not already set
    if (!acc.consortium) {
      acc.consortium = item.consortium;
      acc.screeningDate = item.screeningDate;
      acc.screeningYear = item.screeningYear;
      acc.screeningQuarter = item.screeningQuarter;
      acc.totalMembers = item.totalMembers;
      acc.screenings = [];
    }

    // Calculate percentage selected
    let percentSelected =
      ((item.selectedMembers / item.totalMembers) * 100).toFixed(2) + "%";

    // Add each screening to the screenings array
    acc.screenings.push({
      screeningType: item.screeningType,
      selectedMembers: item.selectedMembers,
      percentSelected: percentSelected,
    });

    return acc;
  }, {});
}

export function aggregateYearlyScreeningsData(screenings) {
  const result = screenings.reduce((acc, item) => {
    // Set common properties if not already set
    if (!acc.screeningYear) {
      acc.screeningYear = item.screeningYear;
      acc.totalMembers = 0; // Initialize to 0
      acc.drugSelected = 0;
      acc.alcoholSelected = 0;
      acc.screenings = [];
      acc.selectedEmployeeResults = {
        drug: {
          selected: 0,
          passed: 0,
          failed: 0,
          wrongTest: 0,
          refused: 0,
          notAtCompany: 0,
          sick: 0,
        },
        alcohol: {
          selected: 0,
          passed: 0,
          failed: 0,
          wrongTest: 0,
          refused: 0,
          notAtCompany: 0,
          sick: 0,
        },
      };
    }

    // Update totalMembers to the largest value
    acc.totalMembers = Math.max(acc.totalMembers, item.totalMembers);

    // Calculate total selected for drug and alcohol separately
    if (item.screeningType.toLowerCase() === "drug") {
      acc.drugSelected += item.selectedMembers;
    } else if (item.screeningType.toLowerCase() === "alcohol") {
      acc.alcoholSelected += item.selectedMembers;
    }

    // Add screening info
    acc.screenings.push({
      screeningType: item.screeningType,
      selectedMembers: item.selectedMembers,
      percentSelected:
        ((item.selectedMembers / item.totalMembers) * 100).toFixed(2) + "%",
    });

    // Count employee results
    item.selectedEmployees.forEach((employee) => {
      let status = employee.status.toLowerCase();
      const screeningType = item.screeningType.toLowerCase();

      // Convert status to camelCase if needed
      if (status === "wrong test") status = "wrongTest";
      if (status === "not at company") status = "notAtCompany";

      if (acc.selectedEmployeeResults[screeningType].hasOwnProperty(status)) {
        acc.selectedEmployeeResults[screeningType][status]++;
      } else {
        console.warn(`Unknown status: ${status}`);
      }
    });

    return acc;
  }, {});

  // Calculate overall percentage selected for drug and alcohol
  result.drugPercentSelected =
    ((result.drugSelected / result.totalMembers) * 100).toFixed(2) + "%";
  result.alcoholPercentSelected =
    ((result.alcoholSelected / result.totalMembers) * 100).toFixed(2) + "%";

  return result;
}

export const randomSelections = async ({
  activeEmployees,
  activeCompanies,
  year,
  quarter,
  percentages,
}) => {
  const { alcoholPercentage, drugPercentage } = percentages[0];

  // Create Set of active company IDs for faster lookup
  const activeCompanyIds = new Set(
    activeCompanies.map((company) => company._id.toString())
  );

  // Filter eligible employees
  const eligibleEmployees = activeEmployees.filter((emp) =>
    activeCompanyIds.has(emp.companyId)
  );

  const consortium = activeEmployees[0]?.consortium || "DOT";

  try {
    // Get previous 2 quarters
    const previousQuarters = getPreviousQuarters(
      parseInt(year),
      parseInt(quarter)
    );

    // Fetch previous screenings
    const previousScreenings = await Promise.all([
      ...previousQuarters.map((q) =>
        axios
          .get(
            `${baseUrl}drug/quarterlySelection/${q.year}/${q.quarter}/${consortium}`
          )
          .then((response) => response.data)
          .catch(() => [])
      ),
      ...previousQuarters.map((q) =>
        axios
          .get(
            `${baseUrl}alcohol/quarterlySelection/${q.year}/${q.quarter}/${consortium}`
          )
          .then((response) => response.data)
          .catch(() => [])
      ),
    ]);

    // Get all previously selected employee IDs
    const previouslySelectedIds = new Set(
      previousScreenings
        .flat()
        .flatMap(
          (screening) =>
            screening?.selectedEmployees?.map(
              (emp) => emp._id || emp.employeeId
            ) || []
        )
    );

    const randomSelection = (n, eligibleEmployees, alreadySelected = []) => {
      let selectedEmployees = [];
      let tempEmployees = eligibleEmployees.filter(
        (emp) =>
          !alreadySelected.includes(emp._id) &&
          !previouslySelectedIds.has(emp._id)
      );

      if (tempEmployees.length < n) {
        console.warn(
          `Warning: Only ${tempEmployees.length} eligible employees available for selection, needed ${n}`
        );
        n = Math.min(n, tempEmployees.length);
      }

      for (let i = 0; i < n && tempEmployees.length > 0; i++) {
        const index = Math.floor(Math.random() * tempEmployees.length);
        const selected = tempEmployees.splice(index, 1)[0];

        selectedEmployees.push({
          employeeId: selected._id,
          firstName: selected.firstName,
          lastName: selected.lastName,
          companyName: selected.companyName,
          companyId: selected.companyId,
          status: "selected",
        });
      }

      return {
        consortium,
        screeningDate: dayjs().tz("US/Central").format("YYYY-MM-DD"),
        screeningQuarter: parseInt(quarter),
        screeningYear: parseInt(year),
        selectedEmployees,
        totalMembers: eligibleEmployees.length,
        selectedMembers: selectedEmployees.length,
        requiredMembers: n,
        isCommitted: false,
      };
    };

    let numberOfDrugSelections = Math.ceil(
      (eligibleEmployees.length * drugPercentage) / 4
    );
    let numberOfAlcoholSelections = Math.ceil(
      (eligibleEmployees.length * alcoholPercentage) / 4
    );

    const drugScreening = randomSelection(
      numberOfDrugSelections,
      eligibleEmployees
    );

    const alreadySelectedIds = drugScreening.selectedEmployees.map(
      (emp) => emp.employeeId
    );

    const alcoholScreening = randomSelection(
      numberOfAlcoholSelections,
      eligibleEmployees,
      alreadySelectedIds
    );

    return {
      drug: drugScreening,
      alcohol: alcoholScreening,
    };
  } catch (error) {
    console.error("Error in randomSelections:", error);
    throw error;
  }
};

// Helper function to get previous quarters
const getPreviousQuarters = (currentYear, currentQuarter) => {
  let quarters = [];
  for (let i = 0; i < 2; i++) {
    currentQuarter--;
    if (currentQuarter < 1) {
      currentQuarter = 4;
      currentYear--;
    }
    quarters.push({ year: currentYear, quarter: currentQuarter });
  }
  return quarters;
};
